module.exports = __webpack_public_path__ + "static/media/bulmag-react-white.b85877f4.png";